import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {ProcessService} from '../../../services/process.service';
import {switchMap} from 'rxjs/operators';
import {NgxTimelineEventChangeSideInGroup} from "@frxjs/ngx-timeline";

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class TimelineComponent implements OnInit {
    process: any;
    constructor(private route: ActivatedRoute, private processService: ProcessService) {
    }
    events = null
    ngOnInit() {
        if (this.route.snapshot.paramMap.get('id')) {
            this.route.paramMap.pipe(
                switchMap((params: ParamMap) => this.processService.getProcess(params.get('id'))))
                .subscribe(process => {
                    setTimeout(() => {
                        this.process = process
                        let approveDate = null
                        this.events = this.process?.tasks?.map( p => {
                            if (p.approveDate) approveDate = new Date(p.approveDate)
                            if (!approveDate) approveDate = new Date();
                            return {timestamp: approveDate, isApproved: p.approveDate != null, title: p.step, description: p.name, key: p.key, status: p.status}
                        })
                    },200);
                });
        }
    }

    getColor(taskStatus) {
        if (taskStatus === 'ONGOING') {
            return '#337AB7F2';
        }
        if (taskStatus === 'DRAFT') {
            return '#8f8f91';
        }
        if (taskStatus === 'APPROVED') {
            return '#18a718';
        }
        if (taskStatus === 'SUBMITTED') {
            return '#beb340';
        }
        if (taskStatus === 'ASSIGNED') {
            return '#b53fa5';
        }
        return '#000000';
    }

    drawCircle(canvasId, color){
        const canvas = document.getElementById(canvasId)
        // @ts-ignore
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = color
        ctx.beginPath()
        ctx.arc(15,15,15,0,Math.PI*2,true)
        ctx.closePath()
        ctx.fill()
        console.log(canvasId, color)
    }

    protected readonly NgxTimelineEventChangeSideInGroup = NgxTimelineEventChangeSideInGroup;
}



